module.exports = __webpack_public_path__ + "img/J13309.d0406aaf.png";